import Publicroutes from "./Routes/Publicroutes";
import "../src/assets/css/Style.css";
import "../src/assets/css/global.css";
import "../src/assets/css/fonts.css";
import "../src/assets/css/colors.css";
import "../src/assets/css/profile.css";
import "../src/assets/css/signup.css";

function App() {
	return (
		<>
			<Publicroutes />
		</>
	);
}

export default App;
